import Nullstack from 'nullstack';
export default function IconCodeAsterix({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-code-asterix",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M6 19a2 2 0 0 1 -2 -2v-4l-1 -1l1 -1v-4a2 2 0 0 1 2 -2"
  }), "   ", Nullstack.element("path", {
    d: "M12 11.875l3 -1.687"
  }), "   ", Nullstack.element("path", {
    d: "M12 11.875v3.375"
  }), "   ", Nullstack.element("path", {
    d: "M12 11.875l-3 -1.687"
  }), "   ", Nullstack.element("path", {
    d: "M12 11.875l3 1.688"
  }), "   ", Nullstack.element("path", {
    d: "M12 8.5v3.375"
  }), "   ", Nullstack.element("path", {
    d: "M12 11.875l-3 1.688"
  }), "   ", Nullstack.element("path", {
    d: "M18 19a2 2 0 0 0 2 -2v-4l1 -1l-1 -1v-4a2 2 0 0 0 -2 -2"
  }), " ");
}